import type { IconNames } from '@repo/foundations/components/Icon/types';
import type { QueriedResource, ResourceIconInfo } from './types';

/**
 * Get the appropriate badge variant for system rating
 */
export const getSystemRatingVariant = (rating: string) => {
	const variants = {
		good: 'success',
		moderate: 'warning',
		poor: 'critical',
	} as const;

	return variants[rating as keyof typeof variants] || 'default';
};

/**
 * Get the appropriate icon for a resource
 */
export function getResourceIcon(resource: QueriedResource): ResourceIconInfo {
	const integrationIconMap: Record<string, IconNames> = {
		snowflake: 'database',
		dbt: 'settings',
		postgres: 'database',
		postgresql: 'database',
		mysql: 'database',
		bigquery: 'database',
		redshift: 'database',
		tableau: 'chartLine',
		looker: 'chartLine',
		powerbi: 'chartLine',
		databricks: 'database',
		github: 'brandChrome',
		slack: 'slack',
		notion: 'fileText',
		airtable: 'table',
		salesforce: 'users',
	};
	if (
		resource.integration_type &&
		integrationIconMap[resource.integration_type.toLowerCase()]
	) {
		return {
			type: 'icon',
			name: integrationIconMap[resource.integration_type.toLowerCase()],
			color: 'text/primary/default',
		};
	}
	const entityIconMap: Record<string, IconNames> = {
		table: 'table',
		view: 'eye',
		chart: 'chartLine',
		dashboard: 'customDashboard',
		document: 'fileText',
		database: 'database',
		schema: 'folder',
		column: 'columns',
		search: 'search',
		question: 'messageCircleQuestion',
	};

	return {
		type: 'icon',
		name: entityIconMap[resource.type] || 'table',
		color: 'text/secondary/default',
	};
}
